// extracted by mini-css-extract-plugin
export default {"generate-notes":"generate-notes_o1K_L","generate-notes-cover":"generate-notes-cover_D84A9","generate-notes-warning":"generate-notes-warning_MC3jt"};